/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { FormattedMessage } from 'react-intl';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  StripeProvider,
  Elements,
  injectStripe
} from 'react-stripe-elements';
import Button from '../../../../components/button/button';
import styles from './paymentpage.module.scss';
import { getStripeKey } from '../../../../utils/helpers';
import Loading from '../../../../components/loading';

const createOptions = () => ({
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      fontFamily: 'Open Sans, sans-serif',
      letterSpacing: '0.025em',
      border: '1px solid red',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#c23d4b'
    }
  }
});

class _CardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      card_error_msg: undefined,
      card_expiry_error_msg: undefined,
      card_cvv_error_msg: undefined
    };
  }

  componentDidMount() {
    const { onRef } = this.props;
    onRef(this);
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    onRef(undefined);
    this.setState({ loader: false });
  }

  handleSkip = () => {
    const { handelNavigation, isAdmin, isDetail, paymentData } = this.props;
    if (isAdmin) {
      handelNavigation(true, paymentData);
      return;
    }
    if (isDetail) {
      handelNavigation(false, paymentData);
    }
  };

  handleSubmit = (e) => {
    const { card_error_msg, card_expiry_error_msg, card_cvv_error_msg } = this.state;
    const { stripe, doPayment } = this.props;
    if (card_error_msg !== '' || card_expiry_error_msg !== '' || card_cvv_error_msg !== '') return;
    e.preventDefault();
    if (stripe) {
      this.setState({ loader: true });
      stripe.createToken().then((payload) => {
        doPayment(payload, card_error_msg, card_expiry_error_msg, card_cvv_error_msg);
      });
    }
  };

  handleChange = (change) => {
    if (change.elementType === 'cardNumber' && !change.complete) {
      this.setState({
        card_error_msg: 'Please enter card number.'
      });
    } else if (change.elementType === 'cardNumber' && change.complete) {
      this.setState({
        card_error_msg: ''
      });
    }
    if (change.elementType === 'cardExpiry' && !change.complete) {
      this.setState({
        card_expiry_error_msg: 'Please enter card expiry date.'
      });
    } else if (change.elementType === 'cardExpiry' && change.complete) {
      this.setState({
        card_expiry_error_msg: ''
      });
    }
    if (change.elementType === 'cardCvc' && !change.complete) {
      this.setState({
        card_cvv_error_msg: 'Please enter card cvv.'
      });
    } else if (change.elementType === 'cardCvc' && change.complete) {
      this.setState({
        card_cvv_error_msg: ''
      });
    }
  };

  render() {
    const {
      card_error_msg,
      card_expiry_error_msg,
      card_cvv_error_msg,
      loader
    } = this.state;
    const { paymentData, isAdmin, isDetail } = this.props;
    return (
      <div>
        <Loading loadingStatus={loader} />
        <div className={styles.inputDetails}>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_number'}
              defaultMessage={'Card Number'}
            />
            <CardNumberElement
              onChange={this.handleChange}
              {...createOptions()}
              className={styles.StripeElement}
            />
            <span style={{ color: 'red' }}>{card_error_msg}</span>
          </div>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_expiry_date'}
              defaultMessage={'Expiration date'}
            />
            <CardExpiryElement
              onChange={this.handleChange}
              {...createOptions()}
              className={styles.StripeElement}
            />
            <span style={{ color: 'red' }}>{card_expiry_error_msg}</span>
          </div>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_cvv'}
              defaultMessage={'CVV'}
            />
            <CardCVCElement
              onChange={this.handleChange}
              {...createOptions()}
              className={styles.StripeElement}
            />
            <span style={{ color: 'red' }}>{card_cvv_error_msg}</span>
          </div>
        </div>
        <hr />
        <div style={{ float: 'right', top: '35px', position: 'relative' }}>
          <div>
            <Button
              className={styles.saveBtn}
              onClick={this.handleSkip}
              translationID="todo.newTask.save1"
              defaultText="Skip"
              disabled={!(isAdmin || isDetail)}
              action="tertiary"
            />
            <Button
              className={`${styles.saveBtn} ml-2`}
              onClick={this.handleSubmit}
              translationID="todo.newTask.save1"
              disabled={!paymentData}
              defaultText="Submit"
              action="secondary"
            />
          </div>
        </div>
      </div>
    );
  }
}

const CardForm = injectStripe(_CardForm);

class PaymentPage extends Component {
    componentDidMount() {
      const { handleGetApplicationDetails } = this.props;
      if (handleGetApplicationDetails) handleGetApplicationDetails();
    }

  doPayment = (tokenDetails, cardNumber, expiryDate, cvvNumber) => {
    const { handlePayment, paymentData } = this.props;
    if (tokenDetails && cardNumber === '' && expiryDate === '' && cvvNumber === '') {
      handlePayment(tokenDetails, paymentData);
    }
  };

  render() {
    const {
      paymentData,
      profileCurrency,
      handelNavigation,
      statusBar,
      paymentModule,
      airportSettings,
      isAdmin,
      isDetail
    } = this.props;
    let stripeKey = getStripeKey(airportSettings);
    if (airportSettings?.enable_multi_wallet_payments) {
      if (paymentModule === 'driver_permit' && airportSettings?.adp_stripe_public_key) {
        stripeKey = airportSettings?.adp_stripe_public_key;
      } else if (paymentModule === 'vehicle_permit' && airportSettings?.avp_stripe_public_key) {
        stripeKey = airportSettings?.avp_stripe_public_key;
      }
    }

    return (
      <div
        className={styles.Container}
        style={{ marginTop: statusBar ? '130px' : '0px' }}
      >
        <div className={styles.Container1}>
          <div className={styles.Container2}>
            <div className={styles.box}>
              <div
                className={`${styles.content} ${styles.embedded}`}
                style={{ marginTop: '25px', padding: '0 38px' }}
              >
                <h5
                  style={{
                    fontWeight: 'bold',
                    color: '#242e42',
                    marginBottom: '20px'
                  }}
                >
                  Scheduling Fees
                </h5>
                <div className={styles.detailsWrapper}>
                  <div
                    className={styles.detailsSection}
                    style={{ margin: '0px', paddingBottom: '0px' }}
                  >
                    <div className={styles.selectedCust}>
                      <div>
                        <span className={styles.billTo}>
                          <FormattedMessage
                            id="invoices_payment.title"
                            defaultMessage="Pay by card"
                          />
                        </span>
                      </div>
                    </div>
                    <div className={styles.fvz}>
                      <span className={styles.billTo}>
                        <NumberFormat
                          displayType="text"
                          value={paymentData}
                          thousandSeparator
                          decimalScale={airportSettings?.decimal_precision || 2}
                          fixedDecimalScale
                          prefix={profileCurrency}
                        />
                      </span>
                    </div>
                  </div>
                  <hr style={{ width: '837px', alignSelf: 'center' }} />
                  <div className={styles.billDetailsWrapper}>
                    <StripeProvider apiKey={stripeKey}>
                      <Elements>
                        <CardForm
                          doPayment={(
                            tokenDetails,
                            cardNumber,
                            expiryDate,
                            cvvNumber
                          ) => this.doPayment(
                              tokenDetails,
                              cardNumber,
                              expiryDate,
                              cvvNumber
                            )
                          }
                          onRef={(ref) => { this.child = ref; }}
                          handelNavigation={handelNavigation}
                          paymentData={paymentData}
                          isAdmin={isAdmin}
                          isDetail={isDetail}
                        />
                      </Elements>
                    </StripeProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentPage;
